import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  data: [],
  loading: false,
  error: null,
  charts: {},
};

const medicalTreatmentSlice = createSlice({
  name: "medicalTreatment",
  initialState,
  reducers: {
    loading(state) {
      state.loading = true;
      state.error = null;
    },
    error(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    setList(state, action) {
      state.loading = false;
      state.data = action.payload;
    },
    statusData(state, action) {
      const foundProduct = state.data.filter(
        (e) => e.id === action.payload?.data?.id
      )[0];
      const index = state.data.indexOf(foundProduct);
      state.data[index] = { ...state.data[index], ...action.payload?.data };
      state.loading = false;
    },
    assignData(state, action) {
      const foundProduct = state.data.filter(
        (e) => e.id === action.payload?.id
      )[0];

      const index = state.data.indexOf(foundProduct);

      state.data[index] = {
        ...state.data[index].medicalSupplier,
        ...action.payload?.data?.freelanceSuppliers,
      };
      state.loading = false;
    },
    setChartsData(state, action) {
      state.loading = false;
      state.charts = action.payload;
    },
  },
});

export const {
  loading,
  error,
  setList,
  assignData,
  statusData,
  setChartsData,
} = medicalTreatmentSlice.actions;

export default medicalTreatmentSlice.reducer;
